/**
 * Earnings client (hand-rolled).
 *
 * Reads the seller-earnings rollup from GET /harvests/earnings: the caller's
 * settled marketplace orders + their recorded off-platform harvest sales, split
 * into the current calendar month and lifetime. Orval is not regenerated for
 * this endpoint yet (TD-124 deferred), so the DTO + client are hand-rolled on
 * the shared axios mutator (src/api/client.ts → fseAxios), mirroring orders.ts.
 *
 * MONEY: `salesAmount` is a PLAIN ZAR decimal STRING (NOT micro-ZARP) — display
 * only via Number() → <Money>, never re-multiplied. Mirrors the
 * HarvestEarningsDto on the API.
 */
import { fseAxios } from './client';
import type { HarvestEarningsDto, HarvestEarningsWindowDto } from './generated/models';

// DTOs are the single source of truth in the generated client (TD-124 regen),
// re-exported under the names the screens use. The client stays hand-rolled
// because it returns the unwrapped body (fseAxios) the Home hero consumes.
export type EarningsWindow = HarvestEarningsWindowDto;
export type HarvestEarnings = HarvestEarningsDto;

/** Fetch the caller's seller earnings (this calendar month + lifetime). */
export function getMyEarnings(signal?: AbortSignal): Promise<HarvestEarnings> {
  return fseAxios<HarvestEarnings>({
    url: '/harvests/earnings',
    method: 'GET',
    signal,
  });
}
